export default __webpack_public_path__ + "static/media/open-times.ca8bca91.svg";